/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppsControllerListAllApps200ResponseInner
 */
export interface AppsControllerListAllApps200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof AppsControllerListAllApps200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppsControllerListAllApps200ResponseInner
     */
    connection: AppsControllerListAllApps200ResponseInnerConnectionEnum;
    /**
     * 
     * @type {string}
     * @memberof AppsControllerListAllApps200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AppsControllerListAllApps200ResponseInner
     */
    description?: string;
}


/**
 * @export
 */
export const AppsControllerListAllApps200ResponseInnerConnectionEnum = {
    Connected: 'connected',
    NotConnected: 'not-connected',
    Expired: 'expired'
} as const;
export type AppsControllerListAllApps200ResponseInnerConnectionEnum = typeof AppsControllerListAllApps200ResponseInnerConnectionEnum[keyof typeof AppsControllerListAllApps200ResponseInnerConnectionEnum];


/**
 * Check if a given object implements the AppsControllerListAllApps200ResponseInner interface.
 */
export function instanceOfAppsControllerListAllApps200ResponseInner(value: object): value is AppsControllerListAllApps200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('connection' in value) || value['connection'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AppsControllerListAllApps200ResponseInnerFromJSON(json: any): AppsControllerListAllApps200ResponseInner {
    return AppsControllerListAllApps200ResponseInnerFromJSONTyped(json, false);
}

export function AppsControllerListAllApps200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppsControllerListAllApps200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'connection': json['connection'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function AppsControllerListAllApps200ResponseInnerToJSON(json: any): AppsControllerListAllApps200ResponseInner {
    return AppsControllerListAllApps200ResponseInnerToJSONTyped(json, false);
}

export function AppsControllerListAllApps200ResponseInnerToJSONTyped(value?: AppsControllerListAllApps200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'connection': value['connection'],
        'name': value['name'],
        'description': value['description'],
    };
}

